import { AxiosPromise } from 'axios';
import {
  CertStatus,
  API_PATH_CERT_STATUS
} from 'data/certStatus/certStatus.types';
import Http from '../../shared/http';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getAllCertStatus(
  deliveryFunctionId: string
): AxiosPromise<ServerResponse<CertStatus>> {
  return http.get(`${API_PATH_CERT_STATUS}/${deliveryFunctionId}`);
}

export function createCertStatus(
  deliveryFunctionId: string,
  body: WithAuditDetails<CertStatus>,
): AxiosPromise<ServerResponse<CertStatus>> {
  return http.post(`${API_PATH_CERT_STATUS}/${deliveryFunctionId}`, body);
}

export function updateCertStatus(
  deliveryFunctionId: string,
  body: WithAuditDetails<CertStatus>,
): AxiosPromise<ServerResponse<CertStatus>> {
  return http.put(`${API_PATH_CERT_STATUS}/${deliveryFunctionId}`, body);
}

export function activateCertStatus(
  deliveryFunctionId: string,
  afType: string,
  liType: string
): AxiosPromise<ServerResponse<CertStatus>> {
  return http.get(`${API_PATH_CERT_STATUS}/${deliveryFunctionId}`);
}

export function deleteCertStatus(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<CertStatus>,
): AxiosPromise<ServerResponse<void>> {
  return http.delete(`${API_PATH_CERT_STATUS}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
